import React, { useContext, useEffect, useRef, useState } from "react";
import "../css/layout.css";
import css from "../Modulecss/Home.module.css";
import axios from "axios";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Rightcontainer from "../Components/Rightcontainer";
import { useDispatch } from "react-redux";
import BetCard from "./BetCard";
import RunningCard from "./RunningCard";
import Header from "../Components/Header";
import io from "../Components/socket";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import guidebutton from "../../assets/images/guidebutton.png";
import socket from "../Components/socket";
import acceptSound from "./accept.mp3";
import findGif from "../css/loading_old.gif";
import playSound from "./accept.mp3";
import { MdOutlineDelete } from "react-icons/md";
import { FiRefreshCcw } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../../apiService/allApi";

export default function Homepage({ rungame, homePlay, users }) {
  // BASE URL
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  let baseUrl;
  if (nodeMode === "development") {
    baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const history = useHistory();
  let userID = useRef();
  const isMounted = useRef(true);
  let str;

  const [user, setUser] = useState();
  const [create, setCreated] = useState([]);
  const [challangeReqRun, setChallangeReqRun] = useState(false);

  const [game_amount, setGame_amt] = useState();

  const [gameData, setGameData] = useState({});

  const [submitProcess, setProcess] = useState(true);
  const [isLoading, setIsloading] = useState(false);
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  const userId = localStorage.getItem("userId");
  const access_token = localStorage.getItem("token");
  const [disable, setDisable] = React.useState(challangeReqRun);
  const [disable_play, setDisable_play] = React.useState(false);
  const [GameList, setGameList] = useState(homePlay);
  const [loadingBattleId, setLoadingBattleId] = useState(null);
  const [fakeBattles, setFakeBattles] = useState([]);

  const req_chall_fun = (allgameId) => {
    getPost(allgameId);
  };

  const disablebtn = (id) => {
    setDisable(true);
    setTimeout(() => {
      setDisable(false);
    }, 10000);
  };

  // const disable_play_btn = () => {
  //   setDisable_play(true);
  //   setTimeout(() => {
  //     setDisable_play(false);
  //   }, 3000);
  // };

  const disable_play_btn = (id) => {
    setLoadingBattleId(id);

    setTimeout(() => {
      setLoadingBattleId(null);
    }, 3000);
  };

  const [game_type, setGame_type] = useState(
    useLocation().pathname.split("/")[2],
  );
  const [game_type2, setGame_type2] = useState(
    useLocation().pathname.split("/")[3],
  );
  const [Game_Ammount, setGame_Ammount] = useState("");

  const ChallengeCreate = async (e) => {
    setIsloading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (game_type == "ludoClassicManual") {
      if (Game_Ammount >= 50 && Game_Ammount <= 50000) {
        try {
          const res = await apiRequest(
            `challange/create`,
            "POST",
            { Game_Ammount, Game_type: game_type },
            headers,
          );
          setGame_amt(res?.data?.data?.Game_Ammount);

          if (res.data.status == false) {
            setIsloading(false);
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "you have already enrolled") {
            setIsloading(false);
            Swal.fire({
              title: "You have already enrolled",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "You can set maximum 2 battle.") {
            setIsloading(false);
            Swal.fire({
              title: "You can set maximum 2 battle.",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Insufficient balance") {
            setIsloading(false);
            Swal.fire({
              title: "Insufficient balance",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (
            res.data.msg ===
            "Game amount should be Greater then 50 and less then 50000"
          ) {
            setIsloading(false);
            Swal.fire({
              title:
                "Game amount should be Greater then 50 and less then 50000",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Set Battle in denomination of 50") {
            setIsloading(false);
            Swal.fire({
              title: "Set Battle in denomination of 50",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Technical Issue, Try after an hour!") {
            setIsloading(false);
            Swal.fire({
              title: "Technical Issue, Try after an hour!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            setIsloading(false);
          }
        } catch (e) {
          setIsloading(false);
          if (e?.response?.status == 401) {
            localStorage.removeItem("token");
            window.location.reload();
          }
          if (e?.response?.status == 400 || e?.response?.status == 429) {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
          console.log(e);
        }
      } else {
        setIsloading(false);
        Swal.fire({
          title: "Please Amount should be greater 50 and less 50000!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } else if (game_type == "ludoClassicRich") {
      if (Game_Ammount >= 550 && Game_Ammount <= 200000) {
        try {
          const res = await apiRequest(
            `challange/create`,
            "POST",
            { Game_Ammount, Game_type: game_type },
            headers,
          );
          setGame_amt(res?.data?.data?.Game_Ammount);

          if (res.data.status == false) {
            setIsloading(false);
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "you have already enrolled") {
            setIsloading(false);
            Swal.fire({
              title: "You have already enrolled",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "You can set maximum 2 battle.") {
            setIsloading(false);
            Swal.fire({
              title: "You can set maximum 2 battle.",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Insufficient balance") {
            setIsloading(false);
            Swal.fire({
              title: "Insufficient balance",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (
            res.data.msg ===
            "Game amount should be Greater then 50 and less then 50000"
          ) {
            setIsloading(false);
            Swal.fire({
              title:
                "Game amount should be Greater then 50 and less then 50000",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Set Battle in denomination of 50") {
            setIsloading(false);
            Swal.fire({
              title: "Set Battle in denomination of 50",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Technical Issue, Try after an hour!") {
            setIsloading(false);
            Swal.fire({
              title: "Technical Issue, Try after an hour!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            setIsloading(false);
          }
        } catch (e) {
          setIsloading(false);
          if (e?.response?.status == 401) {
            localStorage.removeItem("token");
            window.location.reload();
          }
          if (e?.response?.status == 400 || e?.response?.status == 429) {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
          console.log(e);
        }
      } else {
        setIsloading(false);
        Swal.fire({
          title: "Please Amount should be greater 550 and less 200000!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } else {
      try {
        const res = await apiRequest(
          `challange/create`,
          "POST",
          { Game_Ammount, Game_type: game_type },
          headers,
        );
        setGame_amt(res?.data?.data?.Game_Ammount);

        if (res.data.status == false) {
          setIsloading(false);
          Swal.fire({
            title: res.data.msg,
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "you have already enrolled") {
          setIsloading(false);
          Swal.fire({
            title: "You have already enrolled",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "You can set maximum 2 battle.") {
          setIsloading(false);
          Swal.fire({
            title: "You can set maximum 2 battle.",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Insufficient balance") {
          setIsloading(false);
          Swal.fire({
            title: "Insufficient balance",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (
          res.data.msg ===
          "Game amount should be Greater then 50 and less then 50000"
        ) {
          setIsloading(false);
          Swal.fire({
            title: "Game amount should be Greater then 50 and less then 50000",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Set Battle in denomination of 50") {
          setIsloading(false);
          Swal.fire({
            title: "Set Battle in denomination of 50",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Technical Issue, Try after an hour!") {
          setIsloading(false);
          Swal.fire({
            title: "Technical Issue, Try after an hour!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else {
          setIsloading(false);
        }
      } catch (e) {
        setIsloading(false);
        if (e?.response?.status == 401) {
          localStorage.removeItem("token");
          window.location.reload();
        }
        if (e?.response?.status == 400 || e?.response?.status == 429) {
          Swal.fire({
            title: "Please refresh!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        }
        console.log(e);
      }
    }
  };

  const [MyopenBattle, setMyOpenBattle] = useState([]);
  const [OtheropenBattle, setOtherMyOpenBattle] = useState([]);
  const [MyrunningBattle, setMyRunningBattle] = useState([]);
  const [OtherrunningBattle, setOtherRunningBattle] = useState([]);

  useEffect(() => {
    socket.emit("getgamelist", userId);
    socket.on("setGamelist", (data) => {
      setGameList(data);
    });
  }, []);

  useEffect(() => {
    io.on("gameCreate", (data) => {
      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyopenBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtheropenBattle.some((item) => item._id === data._id)) {
          setOtherMyOpenBattle((OtheropenBattle) => [data, ...OtheropenBattle]);
        }
      }
    });
    io.on("deletebat", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle.filter(
          (item) => item._id !== data,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle.filter(
          (item) => item._id !== data,
        );
        return updatedOtheropenBattle;
      });
    });

    io.on("gameUpdate", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedOtheropenBattle;
      });
      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyopenBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtheropenBattle.some((item) => item._id === data._id)) {
          setOtherMyOpenBattle((OtheropenBattle) => [data, ...OtheropenBattle]);
        }
      }
    });

    io.on("startAccepted", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedOtheropenBattle;
      });

      if (data.Status === "running" && data?.Created_by?._id === userId) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      } else if (
        data.Status === "running" &&
        data?.Accepetd_By?._id === userId
      ) {
        if (!MyopenBattle?.some((item) => item?._id === data?._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtherrunningBattle?.some((item) => item?._id === data?._id)) {
          setOtherRunningBattle((OtherrunningBattle) => [
            data,
            ...OtherrunningBattle,
          ]);
        }
      }
    });

    io.on("acceptor_seen_game", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle?.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle?.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedOtheropenBattle;
      });

      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      }
    });
    io.on("challangeAccept", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle?.filter(
          (item) => item._id !== data._id,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle?.filter(
          (item) => item._id !== data._id,
        );
        return updatedOtheropenBattle;
      });

      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      }
    });
  }, [io]);

  function winnAmount(gameAmount) {
    let profit = null;
    if (gameAmount >= 50 && gameAmount <= 250)
      profit = (gameAmount * addCaseSetting?.commissionRange1) / 100;
    else if (gameAmount > 250 && gameAmount <= 500)
      profit = addCaseSetting?.commissionRange2;
    else if (gameAmount > 500)
      profit = (gameAmount * addCaseSetting?.commissionRange3) / 100;
    return gameAmount - profit;
  }

  useEffect(() => {
    let owenedCreated = [];
    let remainingGame = [];

    GameList?.openBattle?.forEach(function (ele) {
      if (ele)
        if (
          (ele?.Created_by?._id == userId || ele?.Accepetd_By?._id == userId) &&
          (ele?.Status == "new" || ele?.Status == "requested")
        ) {
          owenedCreated.push(ele);
        } else if (ele?.Status == "new") {
          remainingGame.push(ele);
        } else if (
          ele?.Status == "running" &&
          ele?.Accepetd_By?._id == userId &&
          ele?.Acceptor_seen === false
        ) {
          owenedCreated.push(ele);
        }
    });
    setMyOpenBattle(owenedCreated);
    setOtherMyOpenBattle(remainingGame);
    let owenedRunning = [];
    let remainingRunning = [];
    GameList?.runningBattle?.forEach(function (ele) {
      if (ele.Created_by && ele.Accepetd_By)
        if (ele.Created_by?._id == userId || ele.Accepetd_By?._id == userId) {
          owenedRunning.push(ele);
        } else {
          remainingRunning.push(ele);
        }
    });
    setMyRunningBattle(owenedRunning);
    setOtherRunningBattle(remainingRunning);
  }, [GameList]);

  useEffect(() => {
    io.on("resultUpdateReq1", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle?.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedMyOpenBattle;
      });

      if (data.Status === "cancelled" || data.Status === "completed") {
        setMyRunningBattle((MyrunningBattle) => {
          const updatedowenedRunning = MyrunningBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          return updatedowenedRunning;
        });
        setOtherRunningBattle((OtherrunningBattle) => {
          const updatedrunningGames = OtherrunningBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          return updatedrunningGames;
        });
      } else {
        const isUserOwned =
          data?.Created_by?._id === userId || data?.Accepetd_By?._id === userId;

        setMyRunningBattle((MyrunningBattle) => {
          const updatedowenedRunning = MyrunningBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          if (isUserOwned) {
            updatedowenedRunning.push(data);
          }
          return updatedowenedRunning;
        });

        setOtherRunningBattle((OtherrunningBattle) => {
          const updatedrunningGames = OtherrunningBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          if (!isUserOwned) {
            updatedrunningGames.push(data);
          }
          return updatedrunningGames;
        });
      }
    });
  }, [io, userId]);

  useEffect(() => {
    let access_token = localStorage.getItem("token");
    if (!access_token) {
      window.location.reload();
    }
  }, []);

  const RunningGames = async () => {
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `challange/running/all`,
        "GET",
        null,
        headers,
      );
      let owenedRunning = [];
      let remainingRunning = [];
      res?.data?.forEach(function (ele) {
        if (ele.Created_by && ele.Accepetd_By)
          if (ele.Created_by?._id == userId || ele.Accepetd_By?._id == userId) {
            owenedRunning.push(ele);
          } else {
            remainingRunning.push(ele);
          }
      });
      setMyRunningBattle(owenedRunning);
      setOtherRunningBattle(remainingRunning);
    } catch (e) {
      console.log("errror", e);
    }
  };

  const AcceptChallang = async (id) => {
    if (str == 1) {
      Swal.fire({
        title: "Other request in process",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
    str = 1;
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `challange/accept/${id}`,
        "PUT",
        { Accepetd_By: headers, Acceptor_by_Creator_at: Date.now() },
        headers,
      );
      setGameData({
        accept_by: res.data.Accepetd_By,
        created_by: res.data.Created_by,
      });

      str = 0;
      if (res.data.status === false) {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (res.data.msg === "you have already enrolled") {
        Swal.fire({
          title: "You have already enrolled",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (res.data.msg === "Insufficient balance") {
        Swal.fire({
          title: "Insufficient balance",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (res.data.msg === "Game already start with other player") {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {
      console.log(e);
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        window.location.reload();
      }
      if (e.response.status == 400) {
        Swal.fire({
          title: e.response.data,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  const RejectGame = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `challange/reject/${id}`,
        "PUT",
        { Accepetd_By: null, Status: "new", Acceptor_by_Creator_at: null },
        headers,
      );
    } catch (e) {
      console.log(e);
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        window.location.reload();
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  const deleteChallenge = async (_id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `challange/delete/${_id}`,
        "DELETE",
        null,
        headers,
      );
      if (res.data.status == false) {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {
      if (e?.response?.status == 401) {
        localStorage.removeItem("token");
        window.location.reload();
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  const updateChallenge = async (_id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `challange/running/update/${_id}`,
        "PUT",
        { Acceptor_seen: true },
        headers,
      );
      if (res) {
        localStorage.setItem("timeOver", "timeStart");
      }
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        window.location.reload();
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      console.log(e);
    }
  };

  const getPost = async (Id) => {
    if (
      game_type === "Ludo Classics" ||
      game_type === "Ludo 1 Goti" ||
      game_type === "Ludo Ulta" ||
      game_type === "Prime Ludo" ||
      game_type === "Ludo Host"
    ) {
      if (submitProcess) {
        setProcess(false);
        setChallangeReqRun(true);
        const access_token = localStorage.getItem("token");
        const headers = {
          authorization: `Bearer ${access_token}`,
        };
        try {
          const res = await apiRequest(
            `challange/requested/running/${game_type}/` + Id,
            "PATCH",
            null,
            headers,
          );
          setProcess(true);
          setChallangeReqRun(false);
          if (res.data.status == false) {
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            history.push(`/viewgame1/${Id}`, {
              prevPath: window.location?.pathname,
            });
          }
        } catch (e) {
          setProcess(true);
          setChallangeReqRun(false);
          if (e?.response?.status == 401) {
            Swal.fire({
              title: "Somthing wrong",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
        }
      }
    } else if (
      game_type === "LudoSnake" ||
      game_type === "LudoPopular" ||
      game_type === "ludoClassicManual" ||
      game_type === "ludoClassicRich"
    ) {
      if (submitProcess) {
        setProcess(false);
        setChallangeReqRun(true);
        const access_token = localStorage.getItem("token");
        const headers = {
          authorization: `Bearer ${access_token}`,
        };
        try {
          const res = await apiRequest(
            "challange/requested/running/" + Id,
            "PATCH",
            {},
            headers,
          );
          setProcess(true);
          setChallangeReqRun(false);

          if (res.data.status == false) {
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            history.push(`/viewgame1/${Id}`, {
              prevPath: window.location?.pathname,
            });
          }
        } catch (e) {
          setProcess(true);
          setChallangeReqRun(false);
          if (e?.response?.status == 401) {
            Swal.fire({
              title: "Somthing wrong",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
        }
      }
    }
  };

  const handleButtonClick = (gameType) => {
    setGame_type(gameType);
  };

  const GameModeChange = () => {
    socket.on("setGamelist", (modeData) => {
      setGameList(modeData);
    });
  };

  const translations = {
    hi: {
      gameadd: "गेम बनाये !",
      gameset: "लगाये",
      openGame: "खुला गेम ",
      challange: "Challange From ",
      entry: "ENTRY FEE",
      prize: "PRIZE",
      play: "PLAY",
      running: "चल रहे गेम ",
      start: "चालू",
      cancel: "रद्द करें",
    },
    en: {
      gameadd: "Create a Battle!",
      gameset: "Set",
      openGame: "Open Battles",
      challange: "Challange From ",
      entry: "ENTRY FEE",
      prize: "PRIZE",
      play: "PLAY",
      running: "Running Battles",
      start: "Start",
      cancel: "Decline",
    },
  };

  const { language } = useContext(LanguageContext);
  const theme = localStorage.getItem("theme");
  const styles = {
    backgroundColor: theme === "light" ? "#d3e3fd" : "black",
    color: theme === "light" ? "black" : "#fff",
  };
  const styles1 = {
    backgroundColor: "#ffcc00",
    color: "black",
    fontWeight: "700",
    border: "none",
    borderRadius: "4px",
    padding: "6px 20px",
    fontSize: "13px",
    textTransform: "uppercase",
    cursor: "pointer",
  };
  const styles3 = {
    backgroundColor: theme === "light" ? "rgb(38, 53, 93)" : "#27241b",
    color: theme === "light" ? "#fff" : "#fff",
  };

 const ranges = [
  [500, 1500],
  [3000, 7000],
  [11000, 15000],
  [20000, 30000],
];

const indianNames = [
  "Aman",
  "Rahul",
  "Rohit",
  "Vikas",
  "Ankit",
  "Neha",
  "Pooja",
  "Riya",
  "Priya",
  "Deepak",
  "Mohit",
  "Karan",
  "Ajay",
  "Sonu",
  "Monu",
];

const attitudeNames = [
  "King",
  "Jaat",
  "Mahakal",
  "Badshah",
  "Legend",
  "Danger",
  "Boss",
  "Sarkar",
  "Don",
  "Royal",
  "Sher",
  "Alpha",
];

const emojis = [
  "🔥",
  "😎",
  "👑",
  "🌹",
  "❤️",
  "💀",
  "⚡",
  "🚩",
  "🦁",
  "💎",
];

const generateRandomString = () => {
  const chars = "abcdefghijklmnopqrstuvwxyz";

  const len = Math.floor(Math.random() * 4) + 5;

  let str = "";

  for (let i = 0; i < len; i++) {
    str += chars[Math.floor(Math.random() * chars.length)];
  }

  return str;
};

const getRandomName = () => {
  const rand = Math.random();

  // Random letters
  if (rand < 0.65) {
    return generateRandomString();
  }

  // Attitude name
  if (rand < 0.85) {
    return attitudeNames[
      Math.floor(Math.random() * attitudeNames.length)
    ];
  }

  // Attitude name + emoji
  if (rand < 0.95) {
    const name =
      attitudeNames[
        Math.floor(Math.random() * attitudeNames.length)
      ];

    const emoji =
      emojis[Math.floor(Math.random() * emojis.length)];

    return `${name}${emoji}`;
  }

  // Emoji only
  return emojis[
    Math.floor(Math.random() * emojis.length)
  ];
};

const getRandomAmount = () => {
  // Fake battle amount: ₹2000 - ₹5000
  const min = 2000;
  const max = 5000;

  // ₹50 ke steps
  const steps = Math.floor((max - min) / 50);

  return (
    min +
    Math.floor(Math.random() * (steps + 1)) * 50
  );
};

const createBattleBatch = () => {
  // Ek baar me 1 ya 2 table generate hogi
  const batchSize =
    [1, 1, 1, 2][
      Math.floor(Math.random() * 4)
    ];

  const battles = [];

  for (let i = 0; i < batchSize; i++) {
    battles.push({
      _id: `fake_${Date.now()}_${Math.random()}`,

      // ₹2000 - ₹5000
      Game_Ammount: getRandomAmount(),

      Status: "new",

      requestedByUser: false,

      Created_by: {
        _id: "bot",
        Name: getRandomName(),
      },
    });
  }

  setFakeBattles((prev) => {
    const updated = [...battles, ...prev];

    // Maximum 6 fake tables
    return updated.slice(0, 6);
  });
};

// Auto generate fake battles
useEffect(() => {
  // Initial tables
  createBattleBatch();

  // New table every 6-10 seconds
  const addInterval = setInterval(
    () => {
      createBattleBatch();
    },
    6000 + Math.random() * 4000
  );

  // Remove random table every 4-9 seconds
  const removeInterval = setInterval(
    () => {
      removeRandomBattle();
    },
    4000 + Math.random() * 5000
  );

  return () => {
    clearInterval(addInterval);
    clearInterval(removeInterval);
  };
}, []);

const handleFakePlay = (battle) => {
  const walletAmount = Number(
    users?.Wallet_balance || 0
  );

  if (walletAmount < battle.Game_Ammount) {
    Swal.fire({
      title: "Insufficient Balance",
      icon: "warning",
    });

    return;
  }

  setFakeBattles((prev) =>
    prev.map((item) =>
      item._id === battle._id
        ? {
            ...item,
            Status: "requested",
            requestedByUser: true,
          }
        : item
    )
  );
};

const handleFakeCancel = (battleId) => {
  setFakeBattles((prev) =>
    prev.map((item) =>
      item._id === battleId
        ? {
            ...item,
            Status: "new",
            requestedByUser: false,
          }
        : item
    )
  );
};

const removeRandomBattle = () => {
  setFakeBattles((prev) => {
    if (prev.length === 0) {
      return prev;
    }

    const randomIndex = Math.floor(
      Math.random() * prev.length
    );

    return prev.filter(
      (_, index) => index !== randomIndex
    );
  });
};
  return (
    <>
      <Header user={users} />
      <div className="leftContainer mb_space " style={styles}>
        <div className="pt-3 mt-5 Orher_page_main_section" style={styles}>
          {(() => {
            const sitSettingRaw = localStorage.getItem("sitSetting");
            if (!sitSettingRaw || sitSettingRaw === "undefined") return null;
            const sitSetting = JSON.parse(sitSettingRaw);
            const manualMsg = sitSetting?.ludoClassicManualMsg;
            const autoMsg = sitSetting?.ludoClassicAutoMsg;
            const showMessage = game_type === "LudoSnake" ? manualMsg : autoMsg;
            if (!showMessage) return null;
            return (
              <div style={styles3}>
                <div className="alrt_msg_div" style={styles3}>
                  <h5 className="">{showMessage}</h5>
                </div>
              </div>
            );
          })()}

          <div>
            {JSON.parse(localStorage.getItem("sitSetting")) == "undefined" ? (
              ""
            ) : JSON.parse(localStorage.getItem("sitSetting"))?.gameSearch ==
              true ? (
              <>
                <div className="battel-bx position-relative">
                  <span className="other_page_small_headings text-dark">
                    {translations[language].gameadd}
                  </span>
                  <span
                    className={`${css.gamesSectionHeadline} info text-uppercase position-absolute font-weight-bold bg-s-1 rounded px-1 mt-0 mb-0 `}
                    style={{ right: "11px", top: "11px" }}
                  >
                    Rules
                    <NavLink to="/Rules">
                      <img
                        className="ml-2"
                        src={
                          process.env.PUBLIC_URL + "/images/Homepage/info.png"
                        }
                        alt=""
                        width="14px"
                      />
                    </NavLink>
                  </span>

                  <div className="user_reder_code_box mt-2">
                    {addCaseSetting.gameSearch && game_type2 != "new" ? (
                      <input
                        className="commaon_input_box"
                        type="tel"
                        placeholder="Enter amount"
                        value={Game_Ammount}
                        onChange={(e) => setGame_Ammount(e.target.value)}
                      />
                    ) : null}

                    <div className="set check_btn">
                      {" "}
                      {!isLoading ? (
                        <>
                          {addCaseSetting.gameSearch && game_type2 != "new" ? (
                            <button
                              className="samll_btn_game samll_btn new_small_btn"
                              onClick={(e) => {
                                e.preventDefault();
                                setGame_Ammount("");
                                ChallengeCreate();
                              }}
                            >
                              {translations[language].gameset}
                            </button>
                          ) : null}
                        </>
                      ) : (
                        <button
                          className={`bg-green ${css.playButton} cxy m-1 position-static `}
                          disabled
                        >
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                          Loading...
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}

            <div className="py-3">
              <div className="mb-3 open_battle_headings">
                <img
                  src={process.env.PUBLIC_URL + "/images/crossswords.png"}
                  alt=""
                  width="30px"
                />
                <span
                  className={`ml-2 ${css.gamesSectionTitle} games_Section_Title`}
                >
                  {translations[language].openGame}
                </span>
              </div>

              {/* ++++++++++++++++++ MY OPEN BATTLE ++++++++++++++++++ */}
              {MyopenBattle &&
                MyopenBattle.filter(
                  (allgame) => allgame?.Game_type === game_type,
                ).map((allgame, index) => (
                  <div
                    key={allgame?._id || index}
                    style={{
                      background:
                        "linear-gradient(180deg, #300c0c 0%, #170505 100%)",
                      borderRadius: "6px",
                      overflow: "hidden",
                      marginBottom: "10px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                      border: "1px solid #240a0a",
                    }}
                  >
                    {/* Thinner Header Section */}
                    <div
                      style={{
                        padding: "6px 12px",
                        borderBottom: "1px solid rgba(255,255,255,0.12)",
                      }}
                    >
                      <span
                        style={{
                          color: "#ffffff",
                          fontSize: "14px",
                          fontWeight: "500",
                          fontFamily: "sans-serif",
                        }}
                      >
                        {translations[language].challange}
                        {allgame.Created_by?.Name.length > 20
                          ? `${allgame.Created_by?.Name.slice(0, 20)}...`
                          : allgame.Created_by?.Name}
                      </span>
                    </div>

                    {/* Minimal Card Content Row */}
                    <div
                      style={{
                        padding: "8px 12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        position: "relative",
                      }}
                    >
                      {/* Compact Metrics Row */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        {/* Compact Entry Fee view */}
                        <div>
                          <div
                            style={{
                              color: "#a0a0a0",
                              fontSize: "10px",
                              fontWeight: "600",
                              marginBottom: "2px",
                              fontFamily: "sans-serif",
                            }}
                          >
                            {translations[language].entry}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <img
                              src="/images/rupee.png"
                              alt="₹"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span
                              style={{
                                color: "#00c853",
                                fontSize: "15px",
                                fontWeight: "700",
                              }}
                            >
                              {allgame?.Game_Ammount}
                            </span>
                          </div>
                        </div>

                        {/* Compact Prize view */}
                        <div>
                          <div
                            style={{
                              color: "#a0a0a0",
                              fontSize: "10px",
                              fontWeight: "600",
                              marginBottom: "2px",
                              fontFamily: "sans-serif",
                            }}
                          >
                            {translations[language].prize}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <img
                              src="/images/rupee.png"
                              alt="₹"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span
                              style={{
                                color: "#00c853",
                                fontSize: "15px",
                                fontWeight: "700",
                              }}
                            >
                              {allgame?.Game_Ammount +
                                winnAmount(allgame?.Game_Ammount)}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Control Actions element rendering area */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          position: "absolute",
                          left: "50%",
                          transform: "translateX(-50%)",
                          zIndex: 2,
                        }}
                      >
                        {userId == allgame?.Created_by?._id &&
                          allgame?.Status == "new" && (
                            <div
                              style={{
                                display: "inline-block",
                                marginRight: "4px",
                              }}
                            >
                              <img
                                src="/images/LandingPage_img/loader1.gif"
                                style={{ width: "20px", height: "20px" }}
                              />
                            </div>
                          )}

                        {userId &&
                          allgame &&
                          userId !== allgame?.Created_by?._id &&
                          allgame?.Status == "new" && (
                            <button
                              disabled={disable_play}
                              style={styles1}
                              onClick={() => {
                                disable_play_btn();
                                AcceptChallang(allgame?._id);
                              }}
                            >
                              {translations[language].play}
                            </button>
                          )}

                        {userId == allgame?.Created_by?._id &&
                          allgame?.Status == "new" && (
                            <button
                              style={{
                                background: "#dc3545",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                padding: "6px 12px",
                                fontSize: "12px",
                                fontWeight: "600",
                              }}
                              onClick={() => deleteChallenge(allgame?._id)}
                            >
                              Delete
                            </button>
                          )}

                        {userId !== allgame?.Created_by?._id &&
                          allgame?.Status == "requested" && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <div
                                className="position-relative text-white btn-sm request_btn"
                                style={{
                                  backgroundColor: "#ffcc00",
                                  padding: "4px 10px",
                                  fontSize: "11px",
                                  borderRadius: "3px",
                                  color: "black",
                                  fontWeight: "600",
                                }}
                              >
                                requested
                              </div>
                              <button
                                className="position-relative btn-sm reject_btn"
                                style={{
                                  padding: "4px 10px",
                                  fontSize: "11px",
                                  borderRadius: "3px",
                                }}
                                onClick={() => RejectGame(allgame?._id)}
                              >
                                cancel
                              </button>
                            </div>
                          )}

                        {userId &&
                          allgame &&
                          userId !== allgame?.Created_by?._id &&
                          allgame?.Status == "running" && (
                            <div>
                              <audio src={playSound} autoPlay></audio>
                              <button
                                disabled={disable}
                                style={{
                                  ...styles1,
                                  background: "#00c853",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  disablebtn();
                                  updateChallenge(allgame?._id);
                                  history.push(`/viewgame1/${allgame?._id}`, {
                                    prevPath: window.location.pathname,
                                  });
                                }}
                              >
                                {translations[language].start}
                              </button>
                            </div>
                          )}

                        {userId == allgame?.Created_by?._id &&
                          allgame.Status == "requested" && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <audio src={acceptSound} autoPlay></audio>
                              <button
                                disabled={disable}
                                style={{
                                  ...styles1,
                                  display: disable ? "none" : "block",
                                }}
                                onClick={(e) => {
                                  disablebtn(allgame?._id);
                                  req_chall_fun(allgame?._id);
                                }}
                              >
                                {translations[language].start}
                              </button>
                              <button
                                className={
                                  disable
                                    ? "btn btn-primary d-block"
                                    : "btn btn-primary d-none"
                                }
                                style={{
                                  padding: "4px 10px",
                                  fontSize: "11px",
                                }}
                              >
                                Wait
                              </button>
                              <button
                                className={
                                  disable
                                    ? "d-none"
                                    : "text-white danger-mix-color position-relative mx-1 fw-bold btn-sm btn-outline-youtube d-block"
                                }
                                style={{
                                  padding: "4px 10px",
                                  fontSize: "11px",
                                }}
                                onClick={() => RejectGame(allgame?._id)}
                              >
                                {translations[language].cancel}
                              </button>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                ))}

              {/* ++++++++++++++++++ OTHER OPEN BATTLE ++++++++++++++++++ */}
              {OtheropenBattle &&
                OtheropenBattle?.filter(
                  (allgame) => allgame?.Game_type === game_type,
                ).map((allgame, index) => (
                  <div
                    key={allgame?._id || index}
                    style={{
                      background:
                        "linear-gradient(180deg, #300c0c 0%, #170505 100%)",
                      borderRadius: "6px",
                      overflow: "hidden",
                      marginBottom: "10px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                      border: "1px solid #240a0a",
                    }}
                  >
                    {/* Thinner Header Section */}
                    <div
                      style={{
                        padding: "6px 12px",
                        borderBottom: "1px solid rgba(255,255,255,0.12)",
                      }}
                    >
                      <span
                        style={{
                          color: "#ffffff",
                          fontSize: "14px",
                          fontWeight: "500",
                          fontFamily: "sans-serif",
                        }}
                      >
                        {translations[language].challange}
                        {allgame.Created_by?.Name.length > 20
                          ? `${allgame.Created_by?.Name.slice(0, 20)}...`
                          : allgame.Created_by?.Name}
                      </span>
                    </div>

                    {/* Minimal Card Content Row */}
                    <div
                      style={{
                        padding: "8px 12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        position: "relative",
                      }}
                    >
                      {/* Compact Metrics Row */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        {/* Compact Entry Fee view */}
                        <div>
                          <div
                            style={{
                              color: "#a0a0a0",
                              fontSize: "10px",
                              fontWeight: "600",
                              marginBottom: "2px",
                              fontFamily: "sans-serif",
                            }}
                          >
                            {translations[language].entry}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <img
                              src="/images/rupee.png"
                              alt="₹"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span
                              style={{
                                color: "#00c853",
                                fontSize: "15px",
                                fontWeight: "700",
                              }}
                            >
                              {allgame?.Game_Ammount}
                            </span>
                          </div>
                        </div>

                        {/* Compact Prize view */}
                        <div>
                          <div
                            style={{
                              color: "#a0a0a0",
                              fontSize: "10px",
                              fontWeight: "600",
                              marginBottom: "2px",
                              fontFamily: "sans-serif",
                            }}
                          >
                            {translations[language].prize}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <img
                              src="/images/rupee.png"
                              alt="₹"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span
                              style={{
                                color: "#00c853",
                                fontSize: "15px",
                                fontWeight: "700",
                              }}
                            >
                              {allgame?.Game_Ammount +
                                winnAmount(allgame?.Game_Ammount)}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Control Actions element rendering area */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          position: "absolute",
                          left: "50%",
                          transform: "translateX(-50%)",
                          zIndex: 2,
                        }}
                      >
                        {userId == allgame?.Created_by?._id &&
                          allgame?.Status == "new" && (
                            <button
                              className="ml-auto delete_buttons"
                              style={{
                                background: "transparent",
                                border: "none",
                                color: "#dc3545",
                                padding: "2px",
                              }}
                              onClick={() => deleteChallenge(allgame?._id)}
                            >
                              <MdOutlineDelete
                                className="card_icons"
                                size={20}
                              />
                            </button>
                          )}

                        {userId == allgame?.Created_by?._id &&
                          allgame?.Status == "requested" && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <button
                                disabled={disable}
                                style={{
                                  ...styles1,
                                  display: disable ? "none" : "block",
                                }}
                                onClick={(e) => {
                                  disablebtn(allgame?._id);
                                  req_chall_fun(allgame?._id);
                                }}
                              >
                                {translations[language].start}
                              </button>
                              <button
                                className={
                                  disable
                                    ? "btn btn-primary d-block"
                                    : "btn btn-primary d-none"
                                }
                                style={{
                                  padding: "4px 10px",
                                  fontSize: "11px",
                                }}
                              >
                                Wait
                              </button>
                              <button
                                style={{
                                  background: "#dc3545",
                                  color: "white",
                                  border: "none",
                                  padding: "4px 10px",
                                  fontSize: "11px",
                                  borderRadius: "3px",
                                }}
                                onClick={() => RejectGame(allgame?._id)}
                              >
                                {translations[language].cancel}
                              </button>
                            </div>
                          )}

                        {userId &&
                          allgame &&
                          userId !== allgame?.Created_by?._id &&
                          allgame?.Status == "new" && (
                            <button
                              disabled={disable_play}
                              style={styles1}
                              onClick={() => {
                                disable_play_btn();
                                AcceptChallang(allgame?._id);
                              }}
                            >
                              {translations[language].play}
                            </button>
                          )}

                        {userId == allgame?.Created_by?._id &&
                          allgame?.Status == "new" && (
                            <div style={{ display: "inline-block" }}>
                              <img
                                src="/images/LandingPage_img/loader1.gif"
                                style={{ width: "20px", height: "20px" }}
                              />
                            </div>
                          )}

                        {userId !== allgame?.Created_by?._id &&
                          allgame?.Status == "requested" && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <div
                                className="position-relative mx-1 text-white btn-sm request_btn"
                                style={{
                                  background: "#ffcc00",
                                  color: "black",
                                  padding: "4px 10px",
                                  fontSize: "11px",
                                  borderRadius: "3px",
                                }}
                              >
                                requested
                              </div>
                              <button
                                className="position-relative mx-1 btn-sm reject_btn"
                                style={{
                                  padding: "4px 10px",
                                  fontSize: "11px",
                                  borderRadius: "3px",
                                }}
                                onClick={() => RejectGame(allgame?._id)}
                              >
                                cancel
                              </button>
                            </div>
                          )}

                        {userId &&
                          userId !== allgame?.Created_by?._id &&
                          allgame?.Status == "running" && (
                            <div>
                              <audio src={playSound} autoPlay></audio>
                              <button
                                disabled={disable}
                                style={{
                                  ...styles1,
                                  background: "#00c853",
                                  color: "white",
                                }}
                                onClick={(e) => {
                                  disablebtn();
                                  updateChallenge(allgame?._id);
                                  history.push(`/viewgame1/${allgame?._id}`, {
                                    prevPath: window.location.pathname,
                                  });
                                }}
                              >
                                {translations[language].start}
                              </button>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
           {fakeBattles.map((allgame, index) => (
  <div
    key={allgame._id}
    className="homepage-battle-card-slide"
    style={{
      background:
        "linear-gradient(180deg, #300c0c 0%, #170505 100%)",
      borderRadius: "6px",
      overflow: "hidden",
      marginBottom: "10px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
      border: "1px solid #240a0a",
    }}
  >
    {/* Header - Same as Open Battle */}
    <div
      style={{
        padding: "6px 12px",
        borderBottom: "1px solid rgba(255,255,255,0.12)",
      }}
    >
      <span
        style={{
          color: "#ffffff",
          fontSize: "14px",
          fontWeight: "500",
          fontFamily: "sans-serif",
        }}
      >
        {translations[language].challange}
        {allgame.Created_by?.Name?.length > 20
          ? `${allgame.Created_by?.Name.slice(0, 20)}...`
          : allgame.Created_by?.Name}
      </span>
    </div>

    {/* Content - Entry Left / Action Center / Prize Right */}
    <div
      style={{
        padding: "8px 12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "relative",
        minHeight: "42px",
      }}
    >
      {/* Entry - LEFT */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            color: "#a0a0a0",
            fontSize: "10px",
            fontWeight: "600",
            marginBottom: "2px",
            fontFamily: "sans-serif",
          }}
        >
          {translations[language].entry}
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <img
            src="/images/rupee.png"
            alt="₹"
            style={{
              width: "20px",
              height: "20px",
            }}
          />

          <span
            style={{
              color: "#00c853",
              fontSize: "15px",
              fontWeight: "700",
            }}
          >
            {allgame.Game_Ammount}
          </span>
        </div>
      </div>

      {/* Actions - EXACT CENTER */}
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          zIndex: 2,
        }}
      >
        {/* PLAY */}
        {allgame.Status === "new" && (
          <button
            disabled={disable_play}
            style={styles1}
            onClick={() => {
              disable_play_btn();
              handleFakePlay(allgame);
            }}
          >
            {translations[language].play}
          </button>
        )}

        {/* REQUESTED */}
        {allgame.Status === "requested" && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "6px",
            }}
          >
            <div
              className="position-relative text-white btn-sm request_btn"
              style={{
                backgroundColor: "#ffcc00",
                padding: "4px 10px",
                fontSize: "11px",
                borderRadius: "3px",
                color: "black",
                fontWeight: "600",
              }}
            >
              requested
            </div>

            <button
              className="position-relative btn-sm reject_btn"
              style={{
                padding: "4px 10px",
                fontSize: "11px",
                borderRadius: "3px",
              }}
              onClick={() => handleFakeCancel(allgame._id)}
            >
              {translations[language].cancel}
            </button>
          </div>
        )}
      </div>

      {/* Prize - RIGHT */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          justifyContent: "center",
          marginLeft: "auto",
        }}
      >
        <div
          style={{
            color: "#a0a0a0",
            fontSize: "10px",
            fontWeight: "600",
            marginBottom: "2px",
            fontFamily: "sans-serif",
          }}
        >
          {translations[language].prize}
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <img
            src="/images/rupee.png"
            alt="₹"
            style={{
              width: "20px",
              height: "20px",
            }}
          />

          <span
            style={{
              color: "#00c853",
              fontSize: "15px",
              fontWeight: "700",
            }}
          >
            {allgame.Game_Ammount +
              winnAmount(allgame.Game_Ammount)}
          </span>
        </div>
      </div>
    </div>
  </div>
))}
            <div className="battle_divider"></div>
            <div className="mb-5">
              <div className="open_battle_headings">
                <img
                  src={
                    process.env.PUBLIC_URL + "/images/Homepage/battleIcon.png"
                  }
                  alt=""
                  width="20px"
                />
                <span
                  className={`ml-2 ${css.gamesSectionTitle} games_Section_Title text-white`}
                  style={{ margin: "0px", color: "white" }}
                >
                  {translations[language].running}
                </span>
              </div>

              {MyrunningBattle &&
                MyrunningBattle.map((runnig) => {
                  if (
                    ((userId == runnig.Accepetd_By._id
                      ? (runnig.Status === "running" &&
                          userId == runnig.Accepetd_By._id &&
                          runnig.Acceptor_seen == true) ||
                        runnig.Status === "pending"
                      : (runnig.Status === "running" &&
                          userId == runnig.Created_by._id) ||
                        runnig.Status === "pending") ||
                      runnig.Status == "conflict") &&
                    (runnig?.Game_type == game_type ||
                      runnig?.Game_type == "ludoClassicManual" ||
                      runnig?.Game_type == "ludoClassicRich" ||
                      runnig?.Game_type == "LudoPopular")
                  )
                    return (
                      <RunningCard
                        key={runnig._id}
                        runnig={runnig}
                        user={users}
                        winnAmount={winnAmount}
                      />
                    );
                })}

              {OtherrunningBattle &&
                OtherrunningBattle.map((runnig) => {
                  if (
                    (userId == runnig?.Accepetd_By?._id ||
                    userId == runnig?.Created_by?._id
                      ? userId == runnig.Accepetd_By._id
                        ? (runnig.Status === "running" &&
                            userId == runnig.Accepetd_By._id &&
                            runnig.Acceptor_seen == true) ||
                          (runnig.Status === "pending" &&
                            runnig.Acceptor_status == null)
                        : (runnig.Status === "running" &&
                            user == runnig.Created_by._id) ||
                          (runnig.Status === "pending" &&
                            runnig.Creator_Status == null)
                      : runnig.Status === "running" ||
                        runnig.Status === "pending") &&
                    (runnig?.Game_type == game_type ||
                      game_type == "ludoClassicManual" ||
                      game_type == "ludoClassicRich")
                  )
                    return (
                      <RunningCard
                        key={runnig._id}
                        runnig={runnig}
                        user={users}
                        winnAmount={winnAmount}
                      />
                    );
                })}
            </div>
          </div>
        </div>
      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
}
